import { NfcVariantOffIcon } from './NfcVariantOffIcon';

/**
 * author: TheChilliPL
 * id 2BD17DBC-5002-4378-B885-A1952D740C0B
 * name nfc-variant-off
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nfc-variant-off.svg
 * tags
 * - Home Automation 
 */
export const NearFieldCommunicationOffIcon = NfcVariantOffIcon;
export default NearFieldCommunicationOffIcon